import React from 'react'

const YoutubeEmbed = ({ url, cssClass, autoPlay = false }) => {
    const embedId = url.split('v=')[1].split('&')[0]
    const autoplayParam = autoPlay ? 'autoplay=1' : ''

    return (
        <div className={`video-responsive ${cssClass}`}>
            <iframe
                width="853"
                height="480"
                src={`https://www.youtube.com/embed/${embedId}?${autoplayParam}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Embedded youtube"
            />
        </div>
    )
}

export default YoutubeEmbed
